import React, { useMemo } from "react";
import { Package } from "lucide-react";
import ProductCard from "../components/ProductCard";
import allProducts from "../data/products.json";
import { PRIMARY_COLOR, ACCENT_BG } from "../App";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const featuredProducts = useMemo(() => {
    return allProducts
      .filter(p => p.rating >= 4.5) // pick bestsellers
      .slice(0, 8);
  }, []);

  return (
    <div className="min-h-screen pt-24 bg-gray-900 text-white font-inter">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-gray-900 pt-16 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 mb-8 md:mb-0 text-center md:text-left">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold mb-4 leading-tight">
              Elevate Your <span className={`${PRIMARY_COLOR}`}>Performance</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-300 mb-8 max-w-full sm:max-w-lg mx-auto md:mx-0">
              World-class, lab-tested supplements delivered from London directly to your door. Purity and professionalism guaranteed.
            </p>
            <button
              onClick={() => navigate("/shop")}
              className={`${ACCENT_BG} text-white px-6 sm:px-8 py-3 rounded-xl text-base sm:text-lg font-bold shadow-teal-500/50 shadow-xl transition-all duration-300 transform hover:scale-[1.02]`}
            >
              Start Shopping Now
            </button>
          </div>
          <div className="md:w-1/2 flex justify-center mt-6 md:mt-0">
            <Package className={`w-36 sm:w-44 md:w-48 h-36 sm:h-44 md:h-48 ${PRIMARY_COLOR} opacity-70`} />
          </div>
        </div>
      </div>

      {/* Featured Products Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 mb-20">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8 sm:mb-10 text-white border-b border-teal-700 pb-3">
          Our Bestsellers
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {featuredProducts.length > 0 ? (
            featuredProducts.map(p => (
              <ProductCard
                key={p.id}
                product={p}
                onClick={() => navigate(`/product/${p.slug}`)}
              />
            ))
          ) : (
            <div className="col-span-full text-center py-16 bg-gray-800 rounded-xl border border-dashed border-gray-700 text-gray-400 text-xl shadow-inner">
              No featured products available.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
